import { FC, useEffect, useRef } from "react";
import EditorJS, { OutputData } from "@editorjs/editorjs";
import { useController } from "react-hook-form";

// Tools
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Paragraph from "@editorjs/paragraph";
import CustomImageTool from "./CustomImageTool";

// Custom tool

interface Props {
  name: string;
  control: any;
  label?: string;
}

const EditorJSEditor: FC<Props> = ({ name, control, label }) => {
  const editorRef = useRef<EditorJS | null>(null);
  const holderRef = useRef<HTMLDivElement | null>(null);

  const {
    field: { onChange, value },
  } = useController({ name, control });

  useEffect(() => {
    if (holderRef.current && !editorRef.current) {
      const editor = new EditorJS({
        holder: holderRef.current,
        data: (value as OutputData) || { blocks: [] },
        onChange: async () => {
          const saved = await editor.saver.save();
          onChange(saved);
        },
        tools: {
          header: Header,
          list: List,
          paragraph: Paragraph,
          image: CustomImageTool,
        },
      });

      editorRef.current = editor;
    }

    return () => {
      if (editorRef.current) {
        editorRef.current.destroy?.();
        editorRef.current = null;
      }
    };
  }, []);

  return (
    <div className="editor-wrapper">
      {label && <label className="block mb-2 font-medium">{label}</label>}
      <div
        ref={holderRef}
        className="border rounded p-2 bg-white min-h-[200px]"
      />
    </div>
  );
};

export default EditorJSEditor;
